define('plugin/group-booking/GroupBookingPlugin',['require','marionette','collection/ProviderCollection','lib/plugin/PluginAbstract','plugin/group-booking/view/GroupBookingView','plugin/group-booking/view/GroupBookingTimelineView','model/ServiceModel','Config'],function (require) {

    var Marionette = require('marionette');
    var ProviderCollection = require('collection/ProviderCollection');
	var PluginAbstract = require('lib/plugin/PluginAbstract');
    var GroupBookingView = require('plugin/group-booking/view/GroupBookingView');
    var GroupBookingTimelineView = require('plugin/group-booking/view/GroupBookingTimelineView');
    var ServiceModel = require('model/ServiceModel');
    var Config = require('Config');

	return PluginAbstract.extend({
	    _providerCollection: null,
        _serviceStepView: null,
		_serviceRegions: {
			count: '.sb_group_booking_count'
		},
        _groupBookingAllowed: true,
        _timelineLayout: null,
        _defaultGroupBooking : 1,
        _maxGroupBooking : 1,
        _minGroupBooking : 1,
        _serviceCollection: null,

        _groupBookingView : null,
        _groupBookingTimelineView : null,
        
        supportedTimelines: [Config.TIMELINE_CLASSES_PLUGIN, Config.TIMELINE_GRID_WEEKLY],

        /**
         * Initialize plugin
         */
        initialize: function () {
            var _this = this;
            this._providerCollection = new ProviderCollection();

            Backbone.Wreqr.radio.channel('step:item').vent.on(
                'render', _.bind(this.onAddChild, this)
            );
            Backbone.Wreqr.radio.channel('timeline').vent.on(
                'shown', _.bind(this.onTimelineShown, this)
            );

            Backbone.Wreqr.radio.channel('booking').vent.on(
                'step:changed', _.bind(this.onStepChanged, this)
            );

            this.updatePredefinedFieldInfo();

            this.listenTo(Config.getInstance(), 'config:changed', function(){
                _this.updatePredefinedFieldInfo();

                if(_this._groupBookingView){
                    _this._groupBookingView.safeRender();
                }
                if(_this._groupBookingTimelineView){
                    _this._groupBookingTimelineView.render();
                }
            });
        },

        onStepChanged: function(data) {
            if (data.step === 'service') {
                this._bookingModel.set('count', null);
                this.triggerMethod('change:count', this._default);
                this._bookingModel.trigger('reset:count');
            }
        },

        updatePredefinedFieldInfo: function () {
            var predefined = Config.getInstance().getOption('predefined') || {};

            if(predefined.group_booking && parseInt(predefined.group_booking)){
                this._defaultGroupBooking = parseInt(predefined.group_booking);
            }

            this._updateMinMaxGroupBookingVariables(true, null);
        },

        _updateMinMaxGroupBookingVariables : function(global, serviceModel){
            var _defaultGroupBooking = this._defaultGroupBooking;
            if(serviceModel){
                global = false;
            }
            var _maxGroupBooking = this._getMaxCount(serviceModel);
            var _minGroupBooking = 1;

            if (_maxGroupBooking > 1) {
                _minGroupBooking = this._getMinCount(serviceModel, _maxGroupBooking);

                if(_maxGroupBooking < _minGroupBooking){
                    _minGroupBooking = _maxGroupBooking;
                }

                if (_maxGroupBooking < _defaultGroupBooking) {
                    _defaultGroupBooking = _maxGroupBooking;
                }
                if (_minGroupBooking > _defaultGroupBooking) {
                    _defaultGroupBooking = _minGroupBooking;
                }
            }

            if (_maxGroupBooking < _defaultGroupBooking) {
                _defaultGroupBooking = _maxGroupBooking;
            }

            if(global){
                this._maxGroupBooking = _maxGroupBooking;
                this._minGroupBooking = _minGroupBooking;
                this._defaultGroupBooking = _defaultGroupBooking;
            }

            return {
                min : _minGroupBooking,
                max : _maxGroupBooking,
                default : _defaultGroupBooking
            }
        },

        initStepManagerEvents: function () {
            this._bookingModel = this._stepManager.getBookingModel();
            this._timeValidateModel = this._stepManager.getTimeValidateModel();
            //this.listenTo(this._stepManager, 'step:init:service', this.addServiceFilter);
            this.listenTo(this._stepManager.getBookingModel(), 'change:service_id', this.resetCount);
        },
        
        onFinishBooking: function () {
            if (_.contains(this.supportedTimelines, Config.getInstance().getTimelineType())) {
                if (this._groupBookingAllowed) {
                    this._stepManager.getBookingModel().set('count', this._defaultGroupBooking);
                }
            }
        },

        resetCount: function (bookingModel, value, extraData) {
            if (extraData && extraData.count_set) {
                return;
            }
            
            // if (!this._stepManager.getBookingModel().get('service_id')) {
            //     return;
            // }
            
            if (_.contains(this.supportedTimelines, Config.getInstance().getTimelineType())) {
                return;
            }

            if (this._groupBookingAllowed) {
                this._stepManager.getBookingModel().set('count', this._defaultGroupBooking);
            }
        },

        onTimelineShown: function (layout) {
            // if we have predefined service for widget, we also need to show group booking on the timeline
            var predefined = Config.getInstance().getOption('predefined') || {};
            var shouldShow = 
                (predefined.service && !predefined.group_booking) 
                || _.contains(this.supportedTimelines, Config.getInstance().getTimelineType());

            if (!shouldShow) {
                return;
            }
        
            // reset count when coming back from details
            // this._stepManager.getBookingModel().set('count', this._defaultGroupBooking);

            this._timelineLayout = layout;

            this._providerCollection.load();
            this.listenTo(this._providerCollection, 'sync', this.showTimelineCountView);

            this.showTimelineCountView();
        },

        showTimelineCountView: function () {
            if (this._timelineLayout && this._timelineLayout.getGroupBookingRegion()) {
                this._timelineLayout.getGroupBookingRegion().reset();
            }

            var bookingModel = this._stepManager.getBookingModel();
            var serviceModel = null;
            if (bookingModel.get('service_id')) {
                var service = bookingModel.get('service');
                if (service) {
                    if (service.is_recurring === true) {
                        service.is_recurring = 1; // for correct ServiceModel parsing
                    }
                    serviceModel = new ServiceModel(service);
                }
            }

            var gbconfig = this._updateMinMaxGroupBookingVariables(true, serviceModel);

            var count = bookingModel.get('count');
            if (!count) {
                count = gbconfig.default;
            } else if (count < gbconfig.min) {
                count = gbconfig.min;
            } else if (count > gbconfig.max) {
                count = gbconfig.max;
            }
            bookingModel.set('count', count);

            if (gbconfig.max <= 1) {
                return;
            }
            
            this._groupBookingTimelineView = new GroupBookingTimelineView({
                bookingModel: bookingModel,
                count: gbconfig.max,
                minCount: gbconfig.min,
                default : gbconfig.default,
            });

            this.listenTo(this._groupBookingTimelineView, 'render', this.triggerRenderEvent);
            this.listenTo(this._groupBookingTimelineView, 'count_changed', this.onTimelineCountChanged);

            if (this._timelineLayout && this._timelineLayout.getGroupBookingRegion() && gbconfig.max > 1) {
                this._timelineLayout.getGroupBookingRegion().show(this._groupBookingTimelineView);
            }
        },

        onTimelineCountChanged : function(count){
            if(this._serviceCollection) {
                this._serviceCollection.performFilters();
            }
        },

        /**
         * Adds count selector for each item
         *
         * @param event
         */
		onAddChild: function (event) {
		    if (event.stepItem !== 'service') {
                return;
            }

            this._providerCollection.load();

            event.view.listenTo(this._providerCollection, 'sync', event.view.render);

			this._initServiceRegions(event.view);

            var serviceModel = event.model;

            var gbconfig = this._updateMinMaxGroupBookingVariables(false, serviceModel);

            if (gbconfig.max <= 1) {
                return;
            }

            this._groupBookingView = new GroupBookingView({
                bookingModel: this._stepManager.getBookingModel(),
                serviceModel: serviceModel,
                count: gbconfig.max,
                minCount: gbconfig.min,
                default : gbconfig.default,
            });

            this.listenTo(this._groupBookingView, 'render', this.triggerRenderEvent);
            this.listenTo(this._groupBookingView, 'change:count', this._onChangeCount);

            if (event.view.getRegion('count').$el.length > 0) {
                event.view.getRegion('count').show(this._groupBookingView);
            }
		},

        triggerRenderEvent: function (view) {
            this.triggerPluginEvent('group:render', view);
        },
        
        _onChangeCount: function (count) {
            var urlBuilder = this._stepManager.getUrlBuilder();
            Backbone.history.navigate(urlBuilder.buildUrl('booking_step'), {'trigger': false});
        },

        /**
         * After save booking set _groupBookingAllowed if multiple booking was used
         *
         * @param BookingServerRequestModel requestModel
         */
        onSaveBooking: function (requestModel) {
            if (requestModel.get('batch_id')) {
                this._groupBookingAllowed = false;
            }
        },

        multipleBookingUpdated: function (hasBatch) {
            this._groupBookingAllowed = !hasBatch;

            if(this._groupBookingView){
                //TODO check if some redraw is possible here
                // console.log(this._groupBookingView);
            }
        },

        /**
         * After finish booking precess reset _groupBookingAllowed flag
         */
        finishBooking: function () {
            this._groupBookingAllowed = true;
        },

        /**
         * Adds group booking regions
         *
         * @param Marionette.ItemView view
         * @private
         */
        _initServiceRegions: function (view) {
            _.each(this._serviceRegions, function (selector, region) {
                view.addRegion(region, selector);
            });
        },

        /**
         * Returns max count for each service
         *
         * @param ServiceModel serviceModel
         * @return Number
         * @private
         */
        _getMaxCount: function (serviceModel) {
            if (!this._groupBookingAllowed || this.isRecurring(serviceModel)) {
                return 1;
            }
            var isClass = serviceModel && serviceModel.get('class_id');

            var count = parseInt(Config.getInstance().getOptionOrDefault('group_bookings_limit', 0));

            var unitMap = serviceModel ? serviceModel.get('unit_map') : {};
            var unitsCount = [];
            
            this._providerCollection.each(function (model) {
                // skip class providers for non-class services
                var isClassProvider = !!model.get('class_id');

                if (serviceModel && isClassProvider && !isClass) {
                    return;
                }

                if (_.isEmpty(unitMap) || unitMap.hasOwnProperty(model.get('id'))) {
                    unitsCount.push(model.get('qty'));
                }
            });

            var limitBookings = 0;
            if (Config.getInstance().getOption('bookings_limit')) {
                limitBookings = parseInt(Config.getInstance().getOption('bookings_limit'));
            }
            if (serviceModel && parseInt(serviceModel.get('bookings_limit')) > 0) {
                limitBookings = parseInt(serviceModel.get('bookings_limit'));
            }

            var unitCount = unitsCount.length ? Math.max.apply(null, unitsCount) : +Infinity;
            if (limitBookings > 0 && unitCount > limitBookings) {
                unitCount = limitBookings;
            }

            if (count !== 0) {
                return Math.min(count, unitCount);
            }

            return Math.max(1, unitCount);
        },
        
        _getMinCount : function (serviceModel, maxCount) {
            if (!this._groupBookingAllowed || this.isRecurring(serviceModel) || !maxCount) {
                return 1;
            }

            var minCount = parseInt(Config.getInstance().getOptionOrDefault('group_bookings_min_limit', 1));
            var minCountPerService = 1;
            if (serviceModel) {
                var mMin = serviceModel.get('min_group_booking')
                minCountPerService = mMin?parseInt(mMin):1;
            }
            minCount = Math.max(minCount, minCountPerService);

            if(maxCount < minCount){
                minCount = maxCount; //maybe set 1 ?
            }

            return minCount;
        },

        isRecurring : function (serviceModel) {
            if(serviceModel && serviceModel.get('is_recurring')){
                return !!parseInt(serviceModel.get('is_recurring'));
            }
            return false;
        },

        // addServiceFilter : function (step, collection) {
        //     this._serviceCollection = collection;
        //
        //     if (_.contains(this.supportedTimelines, Config.getInstance().getTimelineType())) {
        //         this._serviceCollection = collection;
        //         this._serviceCollection.addFilter(_.bind(this.serviceFilter, this));
        //     }
        // },

        /**
         * Filters service model
         *
         * @param Backbone.Model
         * @return Boolean
         */
        // serviceFilter: function (model) {
        //     var serviceMaxGroupBooking = this._getMaxCount(model);
        //     var serviceMinGroupBooking = this._getMinCount(model, serviceMaxGroupBooking);
        //     var currentGroupBooking = this._bookingModel.get('count');
        //
        //     //console.log(model.get('name'), serviceMinGroupBooking, serviceMaxGroupBooking, currentGroupBooking, serviceMinGroupBooking <= currentGroupBooking && currentGroupBooking <= serviceMaxGroupBooking);
        //     //return true;
        //
        //     if(serviceMinGroupBooking <= currentGroupBooking && currentGroupBooking <= serviceMaxGroupBooking){
        //         return true;
        //     }
        //     return  false;
        // },
		
	});
	
});
